import './tt.css';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function AirMap() {
    const navigate = useNavigate();
    const amLogo = process.env.PUBLIC_URL + '/amLogo.PNG';
    const UIC_Trees = process.env.PUBLIC_URL + '/UIC_Trees.jpg';

    const [modalImage, setModalImage] = useState(null);

    const openModal = (image) => {
        setModalImage(image);
    };

    const closeModal = () => {
        setModalImage(null);
    };

    return (
        <div className="AirMap">
            <div className="middle-column">
                <h1>AirMap</h1>
                <h3>Real-time air pollution data around UIC</h3>
                <p>This project was made with the intention of getting real-time air pollution data around the UIC campus and showing it to the user in multiple forms.</p>
                <img src={amLogo} alt="amLogo" onClick={() => openModal(amLogo)} />
                <p>Some of these forms include a Heatmap of the UIC-East Campus, a Graph scene and a Data Scene.</p>
                <p>The data is collected from Arduino sensors which are wired to the breadboard and the to the Arduino itself. The pollution-level sensors I used is called MQ-135 and the ones that measured temperature and humidity are called DHT-11.</p>
                <p>The data is gathered using C/C++ code in the Arduino IDE which pushes the code into the Arduino chip and receives data measurements every ~1 sec. The date then is serialized in 9600 BAUD for easier communication within the computer. <br></br>The units for MQ-135 come in decimal form where anything above 126 is considered dangerous pollution levels, while the humidity measure range is 20%-95% and the temperature measure range 0-50℃. <span>(</span>The user can actually change the temperature Units in the Data Scene<span>)</span>.</p>
                <p>Then the actual application is built with JAVA and JavaFX. This consists of many 'scenes' including the first Welcome scene.</p>
                <img src={UIC_Trees} alt="UIC_Trees" onClick={() => openModal(UIC_Trees)} />
                <p>After continuing the user can immediately see a Heatmap representation of the Air and Temperature levels around UIC-Campus. These nodes constantly checks for updated information and based on the numbers it changes colors. Upon pressing one of the nodes/sensors, a pop-up with continuous data update shows the user more detailed data about that specific node.</p>
                <p>The user then can choose to go and check out the Graph scene which gives a more visual representation of the change in time of the air levels. Other than that, there is also a Data scene that shows all the connected sensors and their respective updating data and a Log scene that shows all the Serialized communication between the Arduino sensors and our JAVA app.</p>
                <p>This project intends to give a simple presentation of how a useful application can be developed for little to no money in the early stages. Scaling this up would require a lot more funding, but it is a fun project nonetheless.</p>
                <button onClick={() => navigate('/')}>Back to Homepage</button>
            </div>
            {modalImage && (
                <div className="modal" onClick={closeModal}>
                    <span className="close" onClick={closeModal}>&times;</span>
                    <img className="modal-content" src={modalImage} alt="Modal" />
                </div>
            )}
        </div>
    );
}

export default AirMap;